import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import Arrival from "../../assets/images/ramchit-2.png";
import LoginImage from "../../assets/images/licensed-image.jpg"

import { BiExitFullscreen, BiFullscreen } from "react-icons/bi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/crm/dashboard");
    }
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post("public/api/login", {
        email: email,
        password: password,
      });

      localStorage.setItem("token", response.data.token);
      navigate("/crm/dashboard");
      window.location.reload();
      if (response.data.success) {

        // localStorage.setItem("role_id", response.data.user.fixed_role_id);
        // localStorage.setItem("user", JSON.stringify(response.data.user));
        // localStorage.setItem("user_id", JSON.stringify(response.data.user.id));
        // localStorage.setItem(
        //   "user_name",
        //   JSON.stringify(response.data.user.name)
        // );

      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.message);

    } finally {
      setLoading(false);
    }
  };

  const toggleFullScreen = () => {
    const doc = window.document;
    const docEl = doc.documentElement;

    const requestFullScreen =
      docEl.requestFullscreen ||
      docEl.mozRequestFullScreen ||
      docEl.webkitRequestFullScreen ||
      docEl.msRequestFullscreen;
    const exitFullScreen =
      doc.exitFullscreen ||
      doc.mozCancelFullScreen ||
      doc.webkitExitFullscreen ||
      doc.msExitFullscreen;

    if (
      !doc.fullscreenElement &&
      !doc.mozFullScreenElement &&
      !doc.webkitFullscreenElement &&
      !doc.msFullscreenElement
    ) {
      requestFullScreen.call(docEl);
    } else {
      exitFullScreen.call(doc);
    }
  };

  return (
    <>

      <div className="flex min-h-screen items-center justify-center bg-gradient-to-r from-indigo-50 to-purple-100 p-6">
        <div className="flex w-full max-w-4xl overflow-hidden rounded-3xl bg-white shadow-2xl lg:flex">
          <div className="w-full p-10 lg:w-1/2">
            <div className="flex justify-center">
              <img className="h-32" src={Arrival} alt="Logo" />
            </div>

            {/* <p className="text-center text-gray-500">Sign in to continue</p> */}
            <form className="mt-6 space-y-6" onSubmit={handleSubmit}>
              <div>
                <label className="block text-sm font-medium text-gray-700">Email</label>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-2 w-full rounded-xl bg-white border  border-[#0f172a3b] px-4 py-3 text-gray-700 shadow-sm focus:border-[#0f172a] focus:ring-2 focus:ring-[#0f172a3b]"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Password</label>
                <input
                  type="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-2 w-full rounded-xl border border-gray-300 px-4 py-3 text-gray-700 shadow-sm focus:border-[#0f172a] focus:ring-2 focus:ring-[#0f172a3b]"
                  required
                />
              </div>
              {errorMessage && (
                <p className="text-sm text-red-600">{errorMessage}</p>
              )}
              {/* <div className="flex items-center justify-between">

                <Link
                  to="/crm/forgot/password"
                  className="text-sm text-[#0f172a] hover:underline"
                >
                  Forgot password?
                </Link>
              </div> */}
              <button
                type="submit"
                className="w-full rounded-xl bg-[#0f172a] px-4 py-3 text-lg font-semibold text-white shadow-md transition-all duration-300 hover:scale-105 hover:from-purple-600 hover:to-indigo-600 focus:ring-2 focus:ring-purple-500"
                disabled={loading}
              >
                {loading ? "Signing in..." : "Sign in"}
              </button>
            </form>
          </div>
          <div className="hidden lg:block lg:w-1/2 relative">
            <img
              className="h-full w-full object-cover rounded-r-3xl"
              src={LoginImage}
              alt="Indian 500 Rupee Note"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col items-center justify-center text-white px-6 text-center">
              {/* <h2 className="text-3xl font-bold">Join Us Today</h2>
            <p className="mt-2 text-lg">Sign in and explore endless possibilities.</p> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
